import { CustomSelect } from "@/features/ui";
import { GenderEnum } from "../gender-enum";
import { genderLabels } from "../gender-labels";

export const GenderSelect = (props) => (
  <CustomSelect
    id="gender"
    options={Object.values(GenderEnum).map((value) => ({
      value: value,
      label: genderLabels[value],
    }))}
    {...props}
  />
);
